import { render, staticRenderFns } from "./AtualizarInformacoes.vue?vue&type=template&id=eb3d85bc&"
import script from "./AtualizarInformacoes.vue?vue&type=script&lang=js&"
export * from "./AtualizarInformacoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports